import { Box, Flex, Text, useToast } from '@chakra-ui/react'
import { Link, useParams } from 'react-router-dom'
import { Timer } from './Timer'
import { ListProducts } from './ListProducts'
import { ColumnsProduct } from './ColumnsProduct'
import { CardsInfo } from './CardsInfo'
import { HeaderInfo } from './HeaderInfo'
import { ResumoPedido } from './ResumoPedido'
import { Observacoes } from './Observacoes'
import { AlertTime } from './AlertTime'
import { api } from '../../../services/api'
import { useMutation, useQuery } from 'react-query'
import { Button } from '../../../components/Button'
import React, { useEffect, useState } from 'react'
import { formatPrice } from '../../../utils/formatPrice'
import { SkeletonLoading } from './SkeletonLoading'
import { AtualizarObservacoes } from './AtualizarObservacoes'
import { format } from 'date-fns'
import { TransformarProposta } from './Alerts/TransformarProposta'
import { IoIosArrowBack } from 'react-icons/io'
import { EnviarLiberacao } from './EnviarLiberacao'
import { Comissoes } from '../NovoOrcamentoPedido/components/Modais/Comissoes'
import { ConfirmarEstoque } from './Modais/ConfirmarEstoque'
import { GerarPedidoProvider } from '../../../contexts/GerarPedidoProvider'
import { GerarPix } from './GerarPix'
import { EnviarCompreGanhe } from './Modais/EnviarCompreGanhe'
import { SolicitarLiberacaoSemCompreGanhe } from './Modais/SolicitarLiberacaoSemCompreGanhe'

async function enviarAprovacao({ numeroNota }) {
  const response = await api.get('site/v2/orcamento-crm/enviar-aprovacao-crm', {
    params: {
      numero_nota: numeroNota,
    },
  })

  return response.data
}

async function getInfoPedido({ numeroNota }) {
  const response = await api.get(`site/v2/orcamento-crm/listar-dados-pedido-crm?numero_nota=${numeroNota}`)

  const infoEntrega = {
    razao_social: response.data.dados_entrega.razao_social?.toLowerCase(),
    cnpj: response.data.dados_entrega.cnpj,
    inscricao_estadual: response.data.dados_entrega.inscricao_estadual,
    endereco: `${response.data.dados_entrega.endereco?.toLowerCase()}, ${response.data.dados_entrega.numero}`,
    cep: response.data.dados_entrega.cep,
    cidade: response.data.dados_entrega.cidade?.toLowerCase(),
    sigla: response.data.dados_entrega.sigla?.toLowerCase(),
    nome_parceiro: response.data.dados_entrega.nome_parceiro?.toLowerCase(),
    email_parceiro: response.data.dados_entrega.email_parceiro?.toLowerCase(),
    telefone: response.data.dados_entrega.telefone,
    celular: response.data.dados_entrega.celular,
    numero_endereco: response.data.dados_entrega.numero,
  }

  const infoFaturamento = {
    razao_social: response.data.dados_faturamento.razao_social?.toLowerCase(),
    cnpj: response.data.dados_faturamento.cnpj,
    inscricao_estadual: response.data.dados_faturamento.inscricao_estadual,
    endereco: `${response.data.dados_faturamento.endereco?.toLowerCase()}, ${response.data.dados_faturamento.numero}`,
    cep: response.data.dados_faturamento.cep,
    cidade: response.data.dados_faturamento.cidade?.toLowerCase(),
    sigla: response.data.dados_faturamento.sigla?.toLowerCase(),
    nome_parceiro: response.data.dados_faturamento.nome_parceiro?.toLowerCase(),
    email_parceiro: response.data.dados_faturamento.email_parceiro?.toLowerCase(),
    telefone: response.data.dados_faturamento.telefone,
    celular: response.data.dados_faturamento.celular,
    numero_endereco: response.data.dados_entrega.numero,
    codigo_parceiro: response.data.dados_faturamento.codigo_parceiro,
  }

  const data = response.data.itens.map((item) => {
    const valorTotalItem = parseFloat(item.preco_venda) * parseInt(item.quantidade)

    return {
      ...item,
      formattedPrecoBase: formatPrice(item.preco_base),
      formattedPrecoSite: formatPrice(item.preco_site),
      formattedPrecoVenda: formatPrice(item.preco_venda),
      formattedQuantidadeEstoque: new Intl.NumberFormat('pt-BR').format(item.quantidade_estoque),
      formattedQuantidadeMaxima: new Intl.NumberFormat('pt-BR').format(item.quantidade_maxima),
      formattedFreteSite: formatPrice(item.frete_site),
      formattedValorTotalItem: formatPrice(valorTotalItem),
      valorTotalItem,
    }
  })

  return {
    ...response.data,
    dados_entrega: infoEntrega,
    dados_faturamento: infoFaturamento,
    itens: data,
  }
}

export function GerarPedido() {
  const containerRef = React.useRef(null)
  const mainRef = React.useRef(null)

  const { pedido } = useParams()
  const toast = useToast({
    position: 'top-right',
    duration: 3000,
    isClosable: true,
  })

  const {
    data: listaInfoPedido = {
      itens: [],
      dados_pedido: {},
      empresa: {},
      consultor: {},
      dados_faturamento: {},
      dados_entrega: {},
      dados_transportadora: {},
    },
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: ['infoPedido', { numeroNota: pedido }],
    queryFn: () => getInfoPedido({ numeroNota: pedido }),
    refetchOnWindowFocus: true,
  })

  const [selectedItems, setSelectedItems] = useState([])

  function handleSelectItem(item) {
    setSelectedItems((prev) => {
      if (prev.includes(item)) {
        return prev.filter((i) => i !== item)
      }

      return [...prev, item]
    })
  }

  const { mutateAsync: enviarAprovacaoF, isLoading: loadingAprovacao } = useMutation({
    mutationFn: enviarAprovacao,
    onSuccess: () => {
      toast({
        title: 'Pedido enviado para aprovação',
        status: 'success',
      })
    },
    onError: (error) => {
      toast({
        title: 'Erro ao enviar pedido para aprovação',
        description: error.response.data.erros,
        status: 'error',
      })
    },
  })

  const {
    dados_pedido: { ligacao_validada },
  } = listaInfoPedido

  async function handleEnviarAprovacao({ numeroNota }) {
    if (!ligacao_validada) {
      return toast({
        title: 'Erro ao enviar pedido para aprovação',
        description: 'É necessário validar a ligação antes de enviar o pedido para aprovação',
        status: 'error',
      })
    }

    await enviarAprovacaoF({ numeroNota })
  }

  const pedidoLiberado = listaInfoPedido?.dados_pedido?.pedido_liberado
  const pedidoAprovado = listaInfoPedido?.dados_pedido?.pedido_aprovado
  const hasStock = listaInfoPedido?.dados_pedido?.valida_estoque

  useEffect(() => {
    if (containerRef.current && pedidoAprovado && !pedidoLiberado) {
      containerRef.current.style.pointerEvents = 'none'
      containerRef.current.style.cursor = 'not-allowed'
    }
  }, [pedidoAprovado, pedidoLiberado])

  useEffect(() => {
    if (mainRef.current && pedidoLiberado) {
      mainRef.current.style.pointerEvents = 'none'
      mainRef.current.style.cursor = 'not-allowed'
    }
  }, [pedidoLiberado])

  const bloqueiaPedido = listaInfoPedido?.dados_pedido?.bloqueia_pedido

  //const valorTotalItens = listaInfoPedido?.itens?.reduce((acc, item) => acc + item.valorTotalItem, 0)

  const hasCompreGanhe = false
  // const hasCompreGanhe = true
  return (
    <GerarPedidoProvider>
      <Box minH="100vh" w="full" bg="white" pb={5} ref={mainRef} pointerEvents={bloqueiaPedido ? 'none' : 'auto'}>
        <Box maxW="1366px" w="full" mx="auto" px={4} pt={5} display="flex" flexDir="column" gap={4}>
          <Flex gap={2}>
            <Button
              as={Link}
              to={`/vendas/orcamento-pedido/${pedido}`}
              leftIcon={<IoIosArrowBack />}
              border={0}
              borderRadius={0}
              bgColor="transparent"
              px={3}
              py={2}
              color="#2D2D2D"
              _hover={{
                bg: '#e2e2e2',
              }}
              fontWeight="normal"
            >
              Voltar
            </Button>
            <TransformarProposta numeroPedido={listaInfoPedido?.dados_pedido?.numero_pedido} numeroNota={pedido} />

            {listaInfoPedido?.dados_pedido?.gerar_pix && <GerarPix numeroNota={pedido} />}
          </Flex>
          <SkeletonLoading animate={isLoading} />
          {isError && (
            <Flex flexDir="column" alignItems="center" justifyContent="center" textAlign="center" fontSize="20px" fontWeight="bold" gap={2}>
              Ocorreu um erro ao carregar as informações do pedido
              <Button onClick={refetch} isLoading={isLoading} loadingText="Carregando...">
                Tentar novamente
              </Button>
            </Flex>
          )}
          {!isLoading && !isError && (
            <>
              <Box display="flex" flexDir="column" gap={4} ref={containerRef}>
                <HeaderInfo numeroNota={pedido} dataPedido={listaInfoPedido.dados_pedido} />

                <CardsInfo
                  empresa={listaInfoPedido.empresa}
                  consultor={listaInfoPedido.consultor}
                  dadosPedido={listaInfoPedido.dados_pedido}
                  dadosFaturamento={listaInfoPedido.dados_faturamento}
                  dadosEntrega={listaInfoPedido.dados_entrega}
                  dadosTransportadora={listaInfoPedido.dados_transportadora}
                  dadosModalEntrega={listaInfoPedido.dados_modal_entrega}
                />

                {/* {hasCompreGanhe && (
                  <Flex gap={2} alignItems="center">
                    <EnviarCompreGanhe {...listaInfoPedido} />
                    <SolicitarLiberacaoSemCompreGanhe {...listaInfoPedido} />
                  </Flex>
                )} */}
                {/* {<EnviarCompreGanhe {...listaInfoPedido} />} */}
                <ColumnsProduct />

                <ListProducts
                  list={listaInfoPedido.itens}
                  handleSelectItem={handleSelectItem}
                  selectedItems={selectedItems}
                  dadosPedido={listaInfoPedido.dados_pedido}
                  dadosFaturamento={listaInfoPedido.dados_faturamento}
                  consultor={listaInfoPedido.consultor}
                  caricatura={pedidoLiberado}
                />
                <ResumoPedido
                  itens={listaInfoPedido.itens}
                  vlrSubstituicaoTributaria={listaInfoPedido.dados_pedido.valor_substituicao}
                  valorFrete={listaInfoPedido.dados_transportadora.valor_frete_30}
                  freteGratis={listaInfoPedido.dados_transportadora.frete_gratis}
                  isDestacaNota={listaInfoPedido.dados_transportadora.destacar_nota}
                />

                <Comissoes numeroNota={pedido} infoProposta={listaInfoPedido.dados_pedido} />
                <Observacoes dadosPedido={listaInfoPedido.dados_pedido} />
              </Box>
              {!hasStock && (
                <ConfirmarEstoque
                  isButtonDisabled={selectedItems.length === 0}
                  enviarAprovacao={() => handleEnviarAprovacao({ numeroNota: pedido })}
                  numeroNota={pedido}
                  itens={listaInfoPedido.itens}
                />
              )}
              {!pedidoAprovado && !pedidoLiberado && hasStock && (
                <Button
                  mx="auto"
                  onClick={() => handleEnviarAprovacao({ numeroNota: pedido })}
                  isLoading={loadingAprovacao}
                  loadingText="Enviando..."
                  disabled={selectedItems.length === 0}
                >
                  Enviar para o Cliente
                </Button>
              )}
              {listaInfoPedido?.dados_pedido?.pagamento_pedido && (
                <Flex flexDir="column" gap={2} textAlign="center" cursor="pointer" pointerEvents={'auto'}>
                  <Text fontSize="sm" color="gray.500">
                    {listaInfoPedido.dados_pedido?.data_pagamento
                      ? format(new Date(listaInfoPedido?.dados_pedido?.data_pagamento), 'dd/MM/yyyy')
                      : 'Pedido não pago'}
                  </Text>

                  <Button mx="auto" as="a" href={listaInfoPedido?.dados_pedido?.link_pdf_pago} target="_blank" rel="noreferrer">
                    Visualizar Pedido Pago
                  </Button>
                </Flex>
              )}
              {listaInfoPedido?.dados_pedido?.enviar_liberacao && <EnviarLiberacao nunota={pedido} isShow={pedidoLiberado} />}
              {pedidoAprovado && (
                <Text size="sm" textAlign="center" color="gray.500" bg="gray.100" p="2" borderRadius="md" w="fit-content" mx="auto">
                  {listaInfoPedido?.dados_pedido?.aprovacao_cliente}
                </Text>
              )}
              {!pedidoAprovado && !pedidoLiberado && <Timer />}
              <AtualizarObservacoes numeroNota={pedido} dadosPedido={listaInfoPedido.dados_pedido} />
              {!pedidoAprovado && !pedidoLiberado && <AlertTime transpPrazo={listaInfoPedido?.dados_pedido?.transp_prazo} />}
            </>
          )}
        </Box>
      </Box>
    </GerarPedidoProvider>
  )
}
